import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const CloseCase = ({ showModal, handleClose }) => {

  const [selectedRole, setSelectedRole] = useState('');
  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const [inputValuer, setInputValuer] = useState('');
  const handleInputChanger = (event) => {
    setInputValuer(event.target.value);
  };
  
  const inputStyling = {
    padding: '8px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '200px',
    height: "45px",
    marginLeft: "45px"
  };

  const dropdownStyling = {
    padding: '3px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
    outline: 'none',
    color: '#333',
    width: '300px',
    height: "35px",
    cursor: 'pointer',
    marginLeft: '85px'
  };

  const dropdownStyler = {
    padding: '3px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
    outline: 'none',
    color: '#333',
    width: '220px',
    height: "30px",
    cursor: 'pointer',
    marginLeft: '50px'
  };

  const [checked, setChecked] = useState(false);
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const [check, setCheck] = useState(false);
  const handleChanged = (event) => {
    setCheck(event.target.checked);
  };

  return (
    <div>
      <Modal show={showModal} onHide={handleClose} dialogClassName="modal-90w" size="lg">
        <Modal.Header closeButton style={{ backgroundColor: '#004aad' }}>
          <Modal.Title className='heading' style={{ color: 'white' }}>Close Case</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>Shipping Details</h5>
          <div style={{
            alignItems: 'center',
            fontSize: '0.9rem',
            marginRight: '20px',
            gap: '50px',
            backgroundColor: '#f2f2f2'
          }}>
            <br />
            <strong style={{marginLeft:"15px"}}>Shipper</strong>
            <select
              value={selectedRole}
              onChange={handleRoleChange}
              style={dropdownStyling}
            >
              <option value="Not Shipper">Not Shipper</option>
              <option value="Local Driver">Local Driver</option>
              <option value="Royal Mail">Royal Mail</option>
              <option value="Other-UPS Courier">Other-UPS Courier</option>
            </select>
            <br /><br />
            <strong style={{marginLeft:"15px"}}>Shipping Cost</strong>
            <input
              type="text"
              value={inputValuer}
              onChange={handleInputChanger}
              style={inputStyling}
              placeholder=""
            />
            <br /><br />
            <strong style={{marginLeft:"15px"}}>Reschedule?</strong>
            <select
              value={selectedRole}
              onChange={handleRoleChange}
              style={dropdownStyler}
            >
              <option value="Keep Aug 4,2024">Keep Aug 4,2024</option>
              <option value="Ship today">Ship today</option>
              <option value="Ship Next Business Day">Ship Next Business Day</option>
            </select>
            <br /><br />
          </div>
       <h5>Additional Actions</h5>
          <div style={{
            alignItems: 'center',
            fontSize: '0.9rem',
            marginRight: '20px',
            gap: '50px',
            backgroundColor: '#f2f2f2'
          }}>
            <br />
            <input
              type="checkbox"
              id="myCheckbox"
              checked={checked}
              onChange={handleChange}
              style={{ padding: "15px", marginLeft: "18px" }}
            />
            <label htmlFor="myCheckbox" style={{ padding: "10px" }}><strong>Related Case</strong></label>
            <input
              type="checkbox"
              id="myCheckbox"
              checked={check}
              onChange={handleChanged}
              style={{ padding: "15px", marginLeft: "18px" }}
            />
            <label htmlFor="myCheckbox" style={{ padding: "10px" }}><strong>Add Shipping Cost to Invoice</strong></label>  <br />  <br />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{
              backgroundColor: '#004aad',
              borderColor: '#004aad',
            }}
          >
            Cancel
          </Button>
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{
              backgroundColor: '#004aad',
              borderColor: '#004aad',
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CloseCase;
